import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import store from "../../../appStore";

const Title = ({ content, showSidebar }) => {
  const { t } = useTranslation();

  const { data } = useSnapshot(store);

  const hasGallery = useMemo(() => {
    if (!content) return false;
    if (data.ContentPagePlaylist?.find((cpp) => cpp.contentPage.id === content.id)) {
      return data.ContentPagePlaylist.find((cpp) => cpp.contentPage.id === content.id).playlist.sequence != null;
    }
    return false;
  }, [data, content]);

  return content !== undefined && content.titleTranslationKey && showSidebar ? (
    <div
      style={{
        padding: "0.5vw 2vw",
        paddingTop: hasGallery ? "0.5vw" : "1.5vw",
        height: "auto",
        wordWrap: "break-word",
      }}
    >
      <h2
        style={{
          color: "#fff",
          fontSize: "1.8vw",
          fontWeight: "100",
          margin: 0,
          marginBottom: 0,
          lineHeight: 1.2,
        }}
      >
        {t(content.titleTranslationKey)}
      </h2>
    </div>
  ) : null;
};

export default Title;
